import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithTokenHandling } from '../baseQuery';
import { GLOBAL_SEARCH_TAG_TYPE } from './constants';

export interface GlobalSearchProvider {
  id: string | number;
  provider_id: string;
  type?: string;
  name?: string;
  first_name?: string;
  last_name?: string;
  npi?: string;
  specialty?: string;
  city?: string;
  state?: string;
  [key: string]: unknown;
}

export interface GlobalSearchResponse {
  providers: GlobalSearchProvider[];
}

export const globalSearchApi = createApi({
  reducerPath: 'globalSearchApi',
  baseQuery: baseQueryWithTokenHandling,
  tagTypes: [GLOBAL_SEARCH_TAG_TYPE],
  endpoints: (builder) => ({
    getGlobalSearch: builder.query<GlobalSearchProvider[], string>({
      query: (searchTerm) => ({
        url: `v1/search/providers/`,
        params: { q: searchTerm },
        method: 'GET',
      }),
      transformResponse: (response: GlobalSearchResponse) =>
        response.providers || [],
      // Skip the query if search term is too short
      serializeQueryArgs: ({ queryArgs }) => queryArgs,
    }),
  }),
});

export const { useGetGlobalSearchQuery } = globalSearchApi;
